/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  products: [],
  error: null,
};

const getters = {
  products: state => state.products,
  error: state => state.error,
};

const actions = {
  fetchConferencesByMonth({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/products/listConferencesByMonth?month=${payload.month}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, products) {
    state.products = [];
    if (products.data) {
      products.data.forEach((el) => {
        state.products.push(el);
      });
    }
    state.error = null;
  },
  [mTypes.REMOVE_DATA](state, productId) {
    const index = state.products.findIndex(obj => obj.id === productId);
    state.products.splice(index, 1);
  },
  [mTypes.CLEAR_STATE](state) {
    state.products = [];
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error === null ? error : error.data.message;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/products.js